import React from "react";
import { HandVector, Fishbanner } from "../../assets/images/index";
import BackButton from "../back-button";
import { useLayoutContext } from "../../layouts/general-layout";
import './login-header.scss';

interface LoginHeaderProps {
  handleBackClick: () => void;
  noImg?: boolean;
  title?: string;
  subtitle?: string;
}

export default function LoginHeader({
  handleBackClick,
  noImg = false,
  title,
  subtitle,
}: LoginHeaderProps) {
  const { t } = useLayoutContext();

  return (
    <div className="login-page-head">
      <div className="login-page-head-inner">
        <div>
          <BackButton onClickBack={handleBackClick} />
        </div>
        <div>
          <h6 className="login-page-title">{title || t("cameBack")}</h6>
        </div>
        <div>
          <p>{subtitle || t("howToGet")}</p>
        </div>
      </div>

      {!noImg && (
        <div className="login-page-image">
          <img src={Fishbanner} alt="Fishbanner" />
        </div>
      )}
    </div>
  );
}
